import keyboardFocus from 'keyboard-focus';
export default () => {
  keyboardFocus(document);
};